import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import SettingElement from '@/game/GameComponents/PhaserGame/UI/SettingElement';
import { UIController } from '@/game/GameComponents/PhaserGame/UI/UIController';
import {
  setBitmapColor,
  shouldSubmitOnPointerUp,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import { HOVER_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';
import SettingToggle from '@/game/prefabs/SettingToggle/SettingToggle';

export class SettingToggleController extends UIController {
  constructor(public settingToggle: SettingToggle) {
    super(settingToggle.scene, settingToggle);
    const { settingLabel, checkbox, interactionHitbox } = this.settingToggle;
    interactionHitbox.setInteractive({ cursor: `${HOVER_CURSOR_PATH}, auto` });
    interactionHitbox.on('pointerup', (e: any) => {
      if (shouldSubmitOnPointerUp(e)) {
        checkbox.brain.handleUserSelection();
      }
    });
    interactionHitbox.on('pointerover', () => {
      if (
        settingToggle.enableTooltip &&
        ResponsivenessManager.GetCurrentGlobalViewForGame(this.scene) !==
          'mobile'
      ) {
        this.settingElement?.setTooltipVisible(true);
      }
      checkbox.brain.handleUserHoverOn();
    });
    interactionHitbox.on('pointerout', () => {
      if (settingToggle.enableTooltip) {
        this.settingElement?.setTooltipVisible(false);
      }
      checkbox.brain.handleUserHoverOff();
    });
    checkbox.on('pointerover', () => {
      if (
        settingToggle.enableTooltip &&
        ResponsivenessManager.GetCurrentGlobalViewForGame(this.scene) !==
          'mobile'
      ) {
        this.settingElement?.setTooltipVisible(true);
      }
    });
    checkbox.on('pointerout', () => {
      this.settingElement?.setTooltipVisible(false);
    });

    // Initialize the setting element.
    this.settingElement = new SettingElement({
      key: settingToggle.key,
      element: settingToggle,
      settingLabel: settingLabel,
      tooltipBacking: settingToggle.tooltipBacking,
      tooltipText: settingToggle.tooltipText,
      helpIcon: settingToggle.helpIcon,
      settingTooltip: settingToggle.settingTooltip,
    });
    this.settingElement.setTooltipVisible(false);
    settingToggle.tooltipDisabledCover.setInteractive({
      cursor: `${HOVER_CURSOR_PATH}, auto`,
    });
    settingToggle.tooltipDisabledCover.on('pointerover', () => {
      if (
        ResponsivenessManager.GetCurrentGlobalViewForGame(this.scene) !==
        'mobile'
      ) {
        this.settingElement?.setTooltipVisible(true);
      }
    });
    settingToggle.tooltipDisabledCover.on('pointerout', () => {
      this.settingElement?.setTooltipVisible(false);
    });
  }

  public settingElement: SettingElement;
  interactiveColor: number = 0x52333f;
  disabledColor: number = 0xbfb09e;

  getIsSelected() {
    const { checkbox } = this.settingToggle;
    return checkbox.brain.isSelected;
  }

  makeInteractive(isInteractive: boolean) {
    const { settingToggle } = this;
    const { checkbox } = this.settingToggle;
    checkbox.brain.setIsInteractive(isInteractive);
    if (isInteractive) {
      settingToggle.settingLabel.setInteractive({
        cursor: `${HOVER_CURSOR_PATH}, auto`,
      });
      settingToggle.tooltipDisabledCover.setVisible(false);
      setBitmapColor(settingToggle.settingLabel, this.interactiveColor);
    } else {
      settingToggle.settingLabel.disableInteractive();
      settingToggle.tooltipDisabledCover.setVisible(true);
      setBitmapColor(settingToggle.settingLabel, this.disabledColor);
    }
  }

  // Sets the callback and clears all others
  setOnSelectionChangedCallback(callback: (newSelection: boolean) => void) {
    const { checkbox } = this.settingToggle;
    checkbox.brain.onSelectionChanged = [callback];
  }

  addOnSelectionChangedCallback(callback: (newSelection: boolean) => void) {
    const { checkbox } = this.settingToggle;
    checkbox.brain.onSelectionChanged.push(callback);
  }

  setSelected(isSelected: boolean) {
    const { checkbox } = this.settingToggle;
    checkbox.brain.setSelected(isSelected);
  }

  correlateWith(otherSettingToggle: SettingToggle) {
    const { checkbox } = this.settingToggle;
    const { checkbox: otherCheckbox } = otherSettingToggle;
    checkbox.brain.correlateWith(otherCheckbox);
    otherCheckbox.brain.correlateWith(checkbox);
  }
}
